import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { useEmployee } from '../context/employee';
import { useSite } from '../context/site';

function IndexPage() {
    const { employee } = useEmployee();
    const { CountAll } = useSite();

    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        CountAll({}, (res) => {
            const data = {
                labels: [
                    'Group Services',
                    'Individual Services',
                    'Program Services',
                    'Parents',
                    'Children',
                    'Programs',
                    'Employees'
                ],
                datasets: [
                    {
                        label: 'Counts',
                        data: [
                            res.data.countServicesGroup,
                            res.data.countServicesIndividual,
                            res.data.countServicesProgram,
                            res.data.countParents,
                            res.data.countChildren,
                            res.data.countPrograms,
                            res.data.countEmployees
                        ]
                    }
                ]
            };
            const options = {
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            };

            setChartData(data);
            setChartOptions(options);
        });
    }, [CountAll]);

    return (
        <Card
            title="Coordinated Family and Community Engagement"
            subTitle="Welcome to the latest CFCE Online app!"
            className="pageCard"
        >
            {employee ? (
                <>
                    <span>
                        Welcome {employee.name}, are you looking for your{' '}
                        <Link to={`/employee/${employee.username}`}>profile</Link> page?
                    </span>

                    <Chart type="bar" data={chartData} options={chartOptions} />
                </>
            ) : (
                <span>
                    Are you looking to <Link to="/sign-in">sign in</Link>?
                </span>
            )}
        </Card>
    );
}

export default IndexPage;
